// ============================================================
// FILE: src/pages/WhyChooseUs.jsx
// ============================================================
import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Users, Award, Clock, TrendingUp, Zap, Wrench, Star } from 'lucide-react';

const WhyChooseUs = () => {
    const reasons = [
        { icon: Shield, title: 'Quality Assurance', desc: 'Strict quality control at every stage of production.' },
        { icon: Users, title: 'Expert Team', desc: 'Highly skilled engineers and fabrication specialists.' },
        { icon: Award, title: 'Industry Recognition', desc: 'Awarded for excellence in steel fabrication.' },
        { icon: Clock, title: 'Timely Delivery', desc: 'Commitment to deadlines without compromising quality.' },
        { icon: TrendingUp, title: 'Innovation', desc: 'Adopting latest technologies and techniques.' },
        { icon: Zap, title: 'Efficiency', desc: 'Optimized processes for cost-effective solutions.' },
        { icon: Wrench, title: 'Customization', desc: 'Bespoke solutions tailored to your needs.' },
        { icon: Star, title: 'Customer Focus', desc: 'Dedicated to exceeding client expectations.' },
    ];

    return (
        <div className="pt-24">
            <section className="section-padding">
                <div className="container-custom">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="text-center mb-12"
                    >
                        <h1 className="text-4xl md:text-5xl font-bold">Why <span className="gradient-text">Choose Us</span></h1>
                        <p className="text-gray-400 mt-2">The Sanwariya Ji advantage</p>
                    </motion.div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {reasons.map((item, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.05 }}
                                className="glass-card p-6 flex gap-4 items-start group hover:bg-white/10 transition-all"
                            >
                                <item.icon className="text-industrialOrange flex-shrink-0 mt-1" size={24} />
                                <div>
                                    <h3 className="text-lg font-bold group-hover:text-industrialOrange transition-colors">{item.title}</h3>
                                    <p className="text-gray-400 text-sm">{item.desc}</p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default WhyChooseUs;